import styled from 'styled-components';
import {
  Link,
  styleMixinFocusOutline,
  styleMixinInvertedFocusOutline,
} from '@amzn/storm-ui';

export const StyledLink = styled(Link)`
  && {
    color: ${({ theme }) => theme.link.color.default};
    text-decoration: none;

    :hover,
    :active {
      color: ${({ theme }) => theme.link.color.hover};
    }

    :focus,
    :focus-visible {
      ${styleMixinFocusOutline};
    }
  }
`;

export const InvertedLink = styled(StyledLink)`
  && {
    color: ${({ theme }) => theme.link.color.inverted};

    :hover,
    :active {
      color: ${({ theme }) => theme.link.color.invertedHover};
    }

    :focus,
    :focus-visible {
      ${styleMixinInvertedFocusOutline};
    }
  }
`;
